import React, { Component } from 'react';
import { get, api, getBranchOwner } from "@config"
import { bindActionCreators } from "redux";
import { connect } from "react-redux";

import { setLoading } from "@inspinia-react/actions";
import { setIcms } from '@taxes/actions'

import TemplateIcms from "./index"
import { mapTest } from '../../../products/map.test';
import { Template as ButtonCreateICMSTemplate } from '../../../../../views/Fiscal/Taxes/ICMS';


class SelectIcms extends Component {
    constructor(props) {
        super(props);
        this.state = {
            list: []
        }
        this.onCreate = this.onCreate.bind(this)
        this.onChange = this.onChange.bind(this)
    }

    getICMS() {
        const branch = getBranchOwner().id
        get(`${api.icms}?branch_owner=${branch}`, list => this.setState({ ...this, list }))
    }

    componentDidMount() {
        this.getICMS()
    }

    onCreate(icms) {
        this.getICMS()
        this.props.setIcms(icms)
        this.setState({ ...this })
        if (this.props.onChangeIcms) {
            this.props.onChangeIcms(icms)
        }
    }

    onChange(e) {
        const selected = this.state.list[e.target.value]
        this.props.setIcms(selected)
        if (this.props.onChangeIcms) {
            this.props.onChangeIcms(selected)
        }
    }

    UNSAFE_componentWillMount() {
        console.log(this.props.icms)
    }

    render() {
        return <div>
            <h2>ICMS</h2>

            <select id={mapTest.createProduct.icms.select} className='form-control' onChange={this.onChange}>
                <option >Selecione o icms</option>
                {this.state.list.map((icms, _) =>
                    <option key={_} value={_} selected={this.props.icms && this.props.icms.id == icms.id} >{icms.name}</option>
                )}
            </select>
            <ButtonCreateICMSTemplate
                onClear={true}
                data={{}}
                onSave={this.onCreate} />
        </div>
    }
}

const mapStateToProps = (state) => ({
    loading: state.loading,
    icms: state.icms
});
const mapDispatchToProps = (dispatch) => bindActionCreators({
    setLoading,
    setIcms
}, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(SelectIcms);


// WEBPACK FOOTER //
// ./src/components/pages/fiscal/taxes/template-icms/select.jsx